import PublicLayout from "@/components/layout/PublicLayout";
import { COMPANY, POLICY } from "@/config/company";

/** Shared shell for the legal pages: title, effective date, numbered sections of paragraphs / bullet lists. */
export default function PolicyPage({ title, intro, sections, testId }) {
  return (
    <PublicLayout>
      <div className="min-h-screen" data-testid={testId}>
        <div className="bg-gradient-to-br from-[#0A183D] to-[#1B3FA0] pt-32 pb-14">
          <div className="max-w-3xl mx-auto px-4">
            <h1 className="font-heading text-3xl sm:text-4xl font-bold text-white">{title}</h1>
            <p className="text-blue-200 mt-3 text-sm">
              {COMPANY.legalName} (brand: {COMPANY.brand}) &middot; Effective {POLICY.effectiveDate}
            </p>
          </div>
        </div>
        <article className="max-w-3xl mx-auto px-4 py-12 text-slate-700 text-[15px] leading-relaxed">
          {intro && <p className="mb-8">{intro}</p>}
          {sections.map((s, i) => (
            <section key={s.h} className="mb-8">
              <h2 className="font-heading text-xl font-semibold text-slate-900 mb-3">{i + 1}. {s.h}</h2>
              {(s.p || []).map((t, j) => <p key={j} className="mb-3">{t}</p>)}
              {s.ul && <ul className="list-disc pl-6 space-y-1.5 mb-3">{s.ul.map((t, j) => <li key={j}>{t}</li>)}</ul>}
            </section>
          ))}
          <p className="text-sm text-slate-500 border-t pt-6">
            Questions about this page: {COMPANY.email} &middot; {COMPANY.phone} &middot; {COMPANY.addressOneLine}.
          </p>
        </article>
      </div>
    </PublicLayout>
  );
}
